import { render, staticRenderFns } from "./FireClaimStaging.vue?vue&type=template&id=46e4edcc&"
import script from "./FireClaimStaging.vue?vue&type=script&lang=js&"
export * from "./FireClaimStaging.vue?vue&type=script&lang=js&"
import style0 from "./FireClaimStaging.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FireClaimStaging.vue"
export default component.exports